module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("date")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.parseDate(_vm.block.date)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("number")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.number))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("hash")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.hash))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("difficulty")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.difficulty))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title"
  }, [_vm._v("miner")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.block.miner))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-860ee1b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 794
// module chunks = 1